import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex,
} from "../../../redux/actions/menuActions";
import KpisContainer from "../../../containers/admin/kpis/KpisContainer";
import MenuActivite from "../Menu";

class Kpis extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftIndex("kpis");
    this.props.setMenuLeftItemIndex("");
  }
  render() {
    return (
      <Fragment>
        <KpisContainer {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Kpis);



// WEBPACK FOOTER //
// src/pages/activite/kpi/Home.js